import {
  WEB_SESSION_KEY, REOPEN_GRACE_KEY, LAST_HEARTBEAT_KEY, PAGEHIDE_KEY, REOPEN_LOCKED_KEY, REOPEN_REPORTED_KEY
} from '../../auth/models/web-session.util';
export class UserIdentity {

  static isAuthenticated(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return (currentUser !== null);
  }

  static getUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  static signOut() {
    const layout = localStorage.getItem('dashboardLayout');
    localStorage.clear();
    if (layout !== null) {
      localStorage.setItem('dashboardLayout', layout);
    }
  }

  // JS-1802: replace the session user after an agency switch, dropping every
  // cached value that may belong to the previous agency (pool).
  static switchAgency(user: any) {
    // JS-1396 idle lock: the device session belongs to the browser, not the
    // agency — losing it here would lock the user right after every switch.
    const preservedKeys = [
      'Language', 'dashboardLayout', 'sidebar', WEB_SESSION_KEY, REOPEN_GRACE_KEY, LAST_HEARTBEAT_KEY, PAGEHIDE_KEY, REOPEN_LOCKED_KEY,
      REOPEN_REPORTED_KEY
    ];
    const preserved = preservedKeys.map(key => [key, localStorage.getItem(key)]);
    localStorage.clear();
    for (const entry of preserved) {
      if (entry[1] !== null) {
        localStorage.setItem(entry[0], entry[1]);
      }
    }
    localStorage.setItem('currentUser', JSON.stringify(user));
  }
}
